module.exports = __webpack_public_path__ + "static/media/ih-login-bg-1080x1920.690947b8.svg";